import script from "./ChatInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatInput.vue?vue&type=script&setup=true&lang=js"

import "./ChatInput.vue?vue&type=style&index=0&id=398ba6ce&lang=scss"

const __exports__ = script;

export default __exports__